import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  getEmptyStateCardSx,
  getEmptyStateTextSx,
  getEmptyStateTitleSx,
} from '../../utils/dashboardSurfaceSx';

/**
 * Consistent empty / no-results surface for dashboard and booking pages.
 * Uses dark glass on mobile shell and dark charcoal cards on desktop dark theme.
 */
export default function EmptyStateCard({
  children,
  themeMode = 'dark',
  title = null,
  sx = {},
  textSx = {},
  dashed = false,
}) {
  return (
    <Box sx={{ ...getEmptyStateCardSx(themeMode, { dashed }), ...sx }}>
      {title ? (
        <Typography variant="h6" sx={{ ...getEmptyStateTitleSx(themeMode), mb: children ? 1 : 0 }}>
          {title}
        </Typography>
      ) : null}
      {children ? (
        typeof children === 'string' || typeof children === 'number' ? (
          <Typography variant="body1" sx={{ ...getEmptyStateTextSx(themeMode), ...textSx }}>
            {children}
          </Typography>
        ) : (
          children
        )
      ) : null}
    </Box>
  );
}
